import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

//hooks
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import ErrorAnalyticsFallback from '@/components/layouts/ErrorFallbacks/ErrorAnalyticsFallback';
//components
import AnalyticsGrid from '@/components/layouts/wrappers/AnalyticsGrid';

export const AnalyticsWrapper = ({
    periodStart,
    periodEnd,
    period,
    compareTo,
    albumId,
    album,
    children,
    className
}) => {
    const { activeSocialProfile } = useActiveSocialProfile();

    return (
        <ErrorBoundary FallbackComponent={ErrorAnalyticsFallback}>
            <AnalyticsGrid className={className}>
                {React.Children.map(children, (child) =>
                    React.cloneElement(child, {
                        activeSocialProfile,
                        periodStart,
                        periodEnd,
                        period,
                        compareTo,
                        albumId,
                        album
                    })
                )}
            </AnalyticsGrid>
        </ErrorBoundary>
    );
};
